import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { useUser } from "../useUserProvider";
import { Profile } from "@/lib/types";
import {
  ElementsQueryData,
  elementsQueryKey,
  elementsQueryOptions,
} from "./elementsQuery";

export const useGetElements = ({
  profiles,
  profileId,
  ...options
}: { profiles: Profile[]; profileId?: string } & Omit<
  UseQueryOptions<
    ElementsQueryData,
    Error,
    ElementsQueryData,
    ReturnType<typeof elementsQueryKey>
  >,
  "queryKey" | "queryFn"
>) => {
  const { user } = useUser();

  return useQuery({
    ...options,
    ...elementsQueryOptions(profileId),
    staleTime: options.staleTime ?? 30_000,
    refetchOnWindowFocus: options.refetchOnWindowFocus ?? false,
    refetchInterval(query) {
      if (
        user?.joinedTeams?.length &&
        profiles?.length &&
        profiles.some(
          profile =>
            profile.id === query.queryKey.at(-1) &&
            user.joinedTeams.some(
              membership => membership.team.id === profile.team?.id,
            ),
        )
      ) {
        return 5 * 60 * 1000;
      }

      return false;
    },
  });
};
